import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocaleSettingsService {
  public culture = 'en-GB';
  public dateFormat = '';
  public timeFormat = '';
  public decimalSeparator = '.';
}
